export interface LifecycleBadge {
  label: string;
  color: string;
}

export const getLifecycleValue = (lifecycleValue: any): string | undefined => {
  if (!lifecycleValue) return undefined;
  if (typeof lifecycleValue === 'string') return lifecycleValue;
  if (typeof lifecycleValue === 'object') {
    return (
      lifecycleValue['en-AU'] ||
      lifecycleValue['en-NZ'] ||
      lifecycleValue['en-US'] ||
      Object.values(lifecycleValue).find((value) => typeof value === 'string')
    );
  }
  return undefined;
};

export const isPrototypeLifecycle = (lifecycleValue: any): boolean => {
  const value = getLifecycleValue(lifecycleValue);
  return value?.toUpperCase().trim() === 'PROTOTYPE';
};

export const getLifecycleBadge = (lifecycleValue: string | undefined): LifecycleBadge | null => {
  if (!lifecycleValue) return null;

  // Normalise: uppercase, trim, collapse underscores + extra spaces
  const val = lifecycleValue
    .toUpperCase()
    .trim()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ');

  // CT values: "OPERATIONAL NEW"
  if (val === 'OPERATIONAL NEW') {
    return { label: 'New', color: '#039103' };
  }

  // CT values: "RUN OUT"
  if (val === 'RUN OUT' || val === 'RUN DOWN') {
    return { label: 'While Stocks Last', color: '#F2AE29' };
  }

  // CT values: "Prototype"
  if (val === 'PROTOTYPE') {
    return { label: 'Coming Soon', color: '#00C8B3' };
  }

  // CT value: "Made to Order-This item may have extended lead times"
  // Use startsWith so any extra text appended after the keyword still matches
  if (val.startsWith('MADE TO ORDER')) {
    return { label: 'Made to Order', color: '#65A1AA' };
  }

  return null;
};

// SKUs that should always show the "Introductory Price" badge, regardless of lifecycle value.
const INTRODUCTORY_PRICE_SKUS = ['PHYPF011-AU'];

export const getIntroductoryPriceBadge = (identifier: unknown): LifecycleBadge | null => {
  if (!identifier) return null;
  const value = String(identifier).trim().toUpperCase();
  if (INTRODUCTORY_PRICE_SKUS.includes(value)) {
    return { label: 'Introductory Price', color: '#039103' };
  }
  return null;
};
